/**
 * ClientApp/src/apps/components/mapViewers/tests/PieMap/index.jsx
 *
 * Sandbox map for comparing cluster-pie rendering approaches.
 * Loads test layers (FeatureLayer + MapImageLayer variants) via
 * usePieMapInit → utils/pieMapUtils.js + utils/clusterPieSmartMapping.js.
 * No tiles/vectors/mapServices/imagery/wms, no loadMapResources call —
 * fully isolated from the production layer pipeline.
 */

import React from 'react';

import "@arcgis/map-components/components/arcgis-map";
import "@arcgis/map-components/components/arcgis-layer-list";
import "@arcgis/map-components/components/arcgis-legend";
import "@arcgis/map-components/components/arcgis-expand";
import "@arcgis/map-components/components/arcgis-zoom";



import { withErrorBoundary } from '@libs/utils/errorBoundaries';
import { APP_CONFIG } from '@config/config';

import usePieMapInit from './hooks/usePieMapInit';
import '@styles/appmap.css';

const PieMap = () => {
  const onarcgisViewReadyChange = usePieMapInit();

  return (
    <div className="map-container">
      <arcgis-map
        basemap="osm"
        zoom={APP_CONFIG.MAPS.LayerList.zoom}
        center={APP_CONFIG.MAPS.LayerList.center}
        onarcgisViewReadyChange={onarcgisViewReadyChange}
      >
        <arcgis-zoom slot="top-right" />

        <arcgis-expand slot="bottom-right">
          <arcgis-legend />
        </arcgis-expand>

        <arcgis-expand
          slot="top-left"
          expanded
        >
          <arcgis-layer-list />
        </arcgis-expand>
      </arcgis-map>
    </div>
  );
};

export default withErrorBoundary(PieMap, {
  componentName: "PieMap"
});